module.exports = {
	a: 'assignArticle',
	qs: 'questionSets',
	expressqs: 'expressQuestionSets',
	v: 'assignVocabulary',
	va: 'vocabularyActivities',
	au: 'assignAudio',
	ebook: 'assignEBook',
	bok: 'assignBookOfKnowledge',
	h: 'requireHighlighting',
	sr: 'assignStepReads',
	ell: 'ell',
	video: 'video',
	challenge: 'challengeArticles',
	support: 'supportArticles',
	wd: 'wordDetective',
	mm: 'meaningMapper',
	decodables: 'decodables'
};
